import { Resources } from '../resource';
import ListComponent from './List';
import ShowComponent from './Show';

export const show = ShowComponent;
export const list = ListComponent;

export const name = Resources.userFeedback;
export const options = {
  label: 'resource.userFeedback',
};